import round from "./round";

//

/**
 * Форматирование числа в валюту
 * @param value - число
 * @param symbol - символ валюты
 * @example
 * formatCurrency(1000) // 1 000 ₸
 * formatCurrency(1000, ' $') // 1 000 $
 * @returns Отформатированное число в валюте
 */

function formatCurrency(value: number, symbol = "₸", space = false) {
  const number = round.afterSign(value, 0);
  const localeNumber = Number(number).toLocaleString("ru");
  const formatedCurrency = `${localeNumber}${space ? " " : ""}${symbol}`;

  return formatedCurrency;
}

//

export default formatCurrency;
